import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiFetchOrg } from 'api/org/apiOrg';
import { ApiOrg } from 'api/org/types/ApiOrg';
import { ApiUnpublishedOrg } from 'api/org/types/ApiUnpublishedOrg';
import { setError } from 'modules/main/store/ducks/error.actions';

import {
  fetchOrgRequest,
  fetchOrgSuccess,
  setOrgUnpublished,
} from './orgsSlice';

export const fetchOrg = createAsyncThunk<ApiOrg | ApiUnpublishedOrg, string>(
  'orgs/fetchOrg',
  // @ts-expect-error TS(2345): Argument of type '(orgId: string, thunkAPI: GetThu... Remove this comment to see the full error message
  async (orgId: string, thunkAPI) => {
    try {
      thunkAPI.dispatch(fetchOrgRequest(orgId));
      const org = await apiFetchOrg(orgId);
      thunkAPI.dispatch(fetchOrgSuccess(org));

      return org;
    } catch (e) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (e.statusCode !== 404) {
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        thunkAPI.dispatch(setError(e));
      } else {
        thunkAPI.dispatch(setOrgUnpublished(orgId));
      }
    }
  },
);
